import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import TrackExamPageContainer from './TrackExamPageContainer';
import TrackPageContainer from './TrackPageContainer';
import TrackIntroPageContainer from './TrackIntroPageContainer';
import TrackFinishedPageContainer from './TrackFinishedPageContainer';
import { TRACK_EXAM_URL_FRAGMENT, TRACK_INTRO_URL_FRAGMENT, TRACK_COMPLETE_URL_FRAGMENT, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { TrackRecommendationsPage } from '../../features/tracks/components/TrackRecommendationsPage';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../../features/playlistContent/index.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackBody = ({
  content,
  lesson,
  lessonFragment,
  lessonProgress,
  track,
  contentFragment,
  contentProgress,
  trackProgress
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const sectionViewProps = isMobile ? undefined : {
    backgroundColor: 'fill-surface-default',
    borderColor: 'border-core-subtle',
    borderRadius: '300',
    borderStyle: 'solid',
    borderWidth: '100',
    overflow: 'hidden'
  };
  switch (lessonFragment) {
    case TRACK_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(TrackFinishedPageContainer, {
          track: track,
          trackProgress: trackProgress
        })
      }));
    case TRACK_EXAM_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(TrackExamPageContainer, {
          track: track,
          trackProgress: trackProgress
        })
      }));
    case TRACK_INTRO_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(TrackIntroPageContainer, {
          track: track
        })
      }));
    case TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT:
      {
        return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
          children: /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
            lessonId: lesson === null || lesson === void 0 ? void 0 : lesson.id,
            navMarkerName: "TRACK_NEXT_IN_PLAYLIST_LOADED",
            trackId: track.id
          })
        }));
      }
    case TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(PlaylistIncompleteItems, {})
      }));
    case TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(PlaylistComplete, {
          navMarkerName: "TRACK_PLAYLIST_COMPLETE_LOADED"
        })
      }));
    case TRACK_RECOMMENDATIONS_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(TrackRecommendationsPage, {
        id: track.id
      });
    default:
      {
        return /*#__PURE__*/_jsx(TrackPageContainer, {
          content: content,
          contentFragment: contentFragment,
          contentProgress: contentProgress,
          lesson: lesson,
          lessonProgress: lessonProgress,
          track: track,
          trackProgress: trackProgress
        });
      }
  }
};
export default TrackBody;